import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import classNames from 'classnames';
import Button from 'src/components/Button';
import LinkButton from 'src/components/Button/LinkButton';
import Icon from 'src/components/Icon';
import NewsTabs, { NewsTabsContainer } from 'src/components/News/NewsTabs';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import { useAdminNews } from './Context';

interface IAdminNewsSidebarProps extends RouteComponentProps {
  activeNewsItemId: number | undefined;
}

const AdminNewsSidebar = ({
  history,
  match,
  activeNewsItemId
}: IAdminNewsSidebarProps) => {
  const news = useAdminNews();

  const isCreateActive = match.url === '/cms/nyheder/opret';
  const isLoading = React.useMemo(() => news.state === 'fetching', [
    news.state
  ]);
  const hasPreviousPage = React.useMemo(() => news.page > 1, [
    news.page,
    news.totalPages
  ]);
  const hasNextPage = React.useMemo(() => news.page < news.totalPages, [
    news.page,
    news.totalPages
  ]);

  const handlePreviousPageClick = React.useCallback(
    () => news.fetchList(news.page - 1),
    [news.page]
  );
  const handleNextPageClick = React.useCallback(
    () => news.fetchList(news.page + 1),
    [news.page]
  );
  const handleItemClick = React.useCallback(
    (item: INewsListItem) => history.push(`/cms/nyheder/${item.id}`),
    []
  );

  React.useEffect(() => {
    news.fetchList();
  }, []);

  return (
    <NewsTabsContainer>
      <div
        className={classNames(
          'mb-1 p-4 relative',
          isCreateActive ? 'has-background-white z-10' : 'has-background-gray-400',
        )}
      >
        <LinkButton
          className="w-full justify-center"
          size="large"
          to="/cms/nyheder/opret"
          color={isCreateActive ? 'gray' : 'success'}
        >
          Opret en nyhed
          <Icon name="pencil" className="w-4 h-4 ml-2" />
        </LinkButton>
      </div>
      <NewsTabs
        news={news.items}
        activeNewsItemId={activeNewsItemId}
        onItemClick={handleItemClick}
      />
      <div className="flex justify-center mt-6">
        <Button
          className="mx-2"
          disabled={!hasPreviousPage}
          loading={isLoading}
          onClick={handlePreviousPageClick}
        >
          <Icon name="chevron-left" className="mr-1" />
          Vis 10 forrige
        </Button>

        <Button
          className="mx-2"
          disabled={!hasNextPage}
          loading={isLoading}
          onClick={handleNextPageClick}
        >
          Vis 10 næste
          <Icon name="chevron-right" className="ml-1" />
        </Button>
      </div>
    </NewsTabsContainer>
  );
};

export default withRouter(AdminNewsSidebar);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/AdminNews/Sidebar.tsx